<template>
  <div class="products-index-base" :style="styles">
    <h1><img src="/static/img/recommend/lp/kurenotori/products/newcorner_lp_head_kurenotori.png" alt="暮れの酉占い特集"></h1>
     <p class="intro-text">占いTVでいま大人気！<br>鳳凰数術をはじめ、多くの占術に精通する<br>暮れの酉先生のおすすめ占いをご紹介します。</p>

    <template v-if="!!resultData && Object.keys(resultData).length > 0">
      <block-biorhythm
        :target-info="counselorInfos"
        :color-scheme="counselorInfos.colorScheme"
        :result-data="resultDataMod.result1"
        :lp-id="lpId"
      />

      <block-next-luckyday
        :result-data="resultDataMod.result2"
      />

      <!--
      <div class="block-next-luckyday" v-if="nextLuckyDayStr.length > 0">
        <div class="wrap">
          <div class="inner">
            <span class="head-luckyday grad">次の「最高」幸運日は…</span>
            <span class="luckyday" v-html="nextLuckyDayStr"></span>
          </div>
        </div>
      </div>
      -->


    </template>


    <div class="regist-birthdate" v-else>
      <p class="error-title">この特集の占いをお楽しみいただくには、<br class="br-pc">以下の情報が必要です。</p>
      <ul>
        <li>・あなたの生年月日</li>
        <li>・あなたの性別</li>
        <li>・あなたの出生地</li>
      </ul>
      <p class="links">こちらのリンクより、情報のご登録をお願いいたします。</p>
      <a href="/user/account/profile">【占いに使う情報を管理】</a>
    </div>

    <div class="block-pickup-fotune">
      <img class="head-img-pickup" src="/static/img/recommend/lp/kurenotori/products/head_pickup.png">
      <ul>
        <li
          v-for="(item, idx) in pickupList"
          :key="`pu-${idx}`"
          @click="onPickupItemClick(idx)"
          v-html="item.label"
        />
      </ul>
      <span class="btn btn-to-fortunelist" @click="onToFortuneListClick">暮れの酉の占い一覧へ</span>
    </div>

     <div class="block-baika-shineki">
      <h3><img class="head-img-baika" src="/static/img/recommend/lp/kurenotori/products/baika-title.png" alt=""></h3>
      <p>気になったとき、何度でも占える「梅花心易」の占いです。</p>
      <img src="/static/img/recommend/lp/kurenotori/products/baika-image.png" alt="">
      <h4>これから、あなたに何が起こる？</h4>
      <p>今のあなたを取り巻く運気と、この先に控えている運命の分岐点を占います。占う瞬間の時刻を用います。</p>
      <span class="btn btn-fortune" @click="onFortuneClickBaikashineki">占う</span>
      <h4>あの人の気持ちと二人の未来</h4>
      <p>気になる恋のお相手の「言葉」を使う、一風変わった占いです。最近かけられたセリフ、SNSのメッセージなど、ふと心に引っかかったときに占ってみてください。</p>
      <ul>
        <li>・お相手の真意</li>
        <li>・あなたに求めるもの</li>
        <li>・二人の未来</li>
        <li>・あなたへのアドバイス</li>
      </ul>
      <span class="btn btn-fortune" @click="onFortuneClickBaikashinekiWords">相手の言葉を入力する</span>
    </div>
    <div class="block-3years-fortune">
      <h3><img class="head-img-3years" src="/static/img/recommend/lp/kurenotori/products/head_your3years_after.png" alt=""></h3>
      <img class="year-img" src="/static/img/recommend/lp/kurenotori/products/img_3years_after.png">
      <span class="btn btn-fortune" @click="onFortuneClickYear">占う</span>
    </div>
    <!-- <div class="block-next-announce">
      <h3>次回更新予告</h3>
      <p>気になったときに何度でも占える、<span class="attention">暮れの酉先生の運命鑑定術</span>を8月に公開予定です。おたのしみに！</p>
    </div> -->
    <!-- <block-biorhythm-test :target-info="counselorInfos" :color-scheme="counselorInfos.colorScheme" :lp-id="lpId"/> -->
    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import * as type from '@/utvStore/store/mutation-types'
import moment from 'moment'

import BlockBiorhythm from './partials/BlockBiorhythm'
import BlockNextLuckyday from './partials/BlockNextLuckyday'
import BannerBlock from './partials/BannerBlock'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

const PICKUP_LIST = [
  {label: '最大の幸運期にあなたが「手に入れるもの」', url:'/menu/8030', tgtBlank:false },
  {label: 'これからあなたが手に入れるもの', url:'/menu/8051', tgtBlank:false },
  {label: '今後ある、一生ものの出会い', url:'/menu/8052', tgtBlank:false },
  {label: 'あなたが今後成し遂げる成功', url:'/menu/8054', tgtBlank:false },
  {label: 'この先あなたが手にする、一生もののご縁とは', url:'/menu/8084', tgtBlank:false },
  // {label: '2022年の運勢', url:'/2022_luck/lp/6203', tgtBlank:false },
  // {label: '2022年下半期の運勢', url:'/2022_luck/lp/6303', tgtBlank:false },
]

export default {
  name: 'ProductsKurenotoriIndex',
  components: {
    RecommendBlockPlus,
    BlockBiorhythm,
    BlockNextLuckyday,
    BannerBlock,
  },
  props: {
    nextLuckyDay: {
      type: String,
      default: '',
    },
    resultData: {
      type: [Array, Object],
      default() {
        return null
      }
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      lpId: 1,
      regBirthValid: false,
      regBirthErr: '',
      regBirthInit: false,
      regBirthVal: null,
    }
  },
  computed: {
    resultDataMod() {
      //20221027リリース施策
      return this.resultData
    },
    pickupList() {
      return PICKUP_LIST
    },
    /*
    nextLuckyDayStr() {
      const mtc = this.nextLuckyDay.match(/(\d{4})年(\d+)月(\d+)日/)
      const dt = !!mtc ? moment([+mtc[1],+mtc[2]-1, +mtc[3]]) : null
      return !!dt ? `<span class="grad">${dt.format('YYYY')}年</span><span class="grad">${dt.format('M')}月</span><span class="grad">${dt.format('D')}日</span>` : ''
    },
     */
    formatedBirthdate() {
      return !!this.regBirthVal ? this.regBirthVal.format('YYYY-MM-DD') : ''
    },
    counselorInfos(){
      return BASIC_DATA.kurenotori
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  methods: {
    onPickupItemClick(val){
      const dt = PICKUP_LIST[val]
      // console.log('クリック[%s] %s %O', val, dt.label.substring(0,8), dt)
      if(!!dt){
        if(dt.tgtBlank){
          window.open(dt.url, '_blank')
        } else {
          location.href = dt.url
        }
      } else {
        console.error('Error: アイテムデータが存在しません')
      }

    },
    onToFortuneListClick(){
      // console.log('暮れの酉の占い一覧へクリック')
      location.href = '/tag/444'
    },
    onFortuneClickYear(){
      // console.log('占うクリック')
      location.href = '/products/86/0001/result'
    },
    onFortuneClickBaikashinekiWords(){
      // console.log('占うクリック')
      location.href = '/products/86/0003/input'
    },
    onFortuneClickBaikashineki(){
      // console.log('占うクリック')
      location.href = '/products/86/0002/result'
    },
    onBirthdayChange(val){
      if(!this.regBirthInit){
        this.regBirthInit = true
      }else {
        if (val.length === 8) {
          const y = val.substring(0, 4)
          const m = val.substring(4, 6)
          const d = val.substring(6, 8)

          const now = new moment()
          const mom = new moment([+y,+m-1,+d])

          if (mom.isBetween('1940-01-01', now, null, '[)') && mom.isValid()){
            this.regBirthErr = ''
            this.regBirthVal = mom
            this.regBirthValid = true
          }else{
            this.regBirthErr = '正しい日付を入力してください'
            this.regBirthValid = false
            this.regBirthVal = null
          }
        } else {
          this.regBirthErr = ''
          this.regBirthValid = false
          this.regBirthVal = null

        }
      }
    },
    onRegBirthSubmitClick(){
      this.$refs.regbirth.submit()
    }
  }
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";

$tori_navy:#142254;
$tori_lightblue:#f3feff;

/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
h1 {
  margin: 0 0 12px;
}
.products-index-base {
  background: url(/static/img/recommend/lp/kurenotori/bg_tori_3nen.png) repeat-y;
  background-size: 100% auto;
}
/*
.block-next-luckyday {
  padding: 0 20px;
  position: relative;
  overflow: hidden;
  .wrap {
    --v-pad-sp: 8px;
    --v-pad-pc: 12px;
    width: 100%;
    height: 0;
    position: relative;
    padding-top: calc(37.75% + var(--v-pad-sp) + var(--v-pad-sp));
    @include mq('w580'){
      padding-top: calc(37.75% + var(--v-pad-pc) + var(--v-pad-pc));
    }
    .inner {
      background: url(/static/img/recommend/lp/kurenotori/products/next_lucky_date_base.png) no-repeat top var(--v-pad-sp) center;
      background-size: 100% auto;
      padding: var(--v-pad-sp) 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      @include mq('w580'){
        padding: var(--v-pad-pc) 0;
        background: url(/static/img/recommend/lp/kurenotori/products/next_lucky_date_base.png) no-repeat top var(--v-pad-pc) center;
        background-size: 100% auto;
      }
    }
    &::after,
    &::before {
      width: 200%;
      border-top: 1px solid $tori_navy;
      content: "";
      position: absolute;
      display: block;
    }
    &::after {
      bottom: 0;
      left: 0;
    }
    &::before {
      top: 0;
      right: 0;
    }

  }

  /deep/ .grad {
    display: inline-block;
    background: linear-gradient(270deg, #5beae8 0%, #537fe4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .head-luckyday {
    font-weight: 600;
    font-size: 18px;
    line-height: 1;
  }
  .luckyday{
    display: inline-block;
    background: -webkit-gradient(linear, right top, left top, from(#5beae8), to(#537fe4));
    background: linear-gradient(270deg, #5beae8 0%, #537fe4 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    font-size: 26px;
  }
}
*/


.block-pickup-fotune, .block-3years-fortune{
  background: #fff;
  margin: 20px;
  border: 1px solid $tori_navy;
  border-radius: 10px;
  padding: 40px 20px;
  ul{
    margin-bottom: 12px;
  }
  li{
    font-weight: 600;
    font-size: 14px;
    color: $tori_navy;
    padding: 20px 0;
    border-bottom: 1px solid #dadada;
    position: relative;
    padding-right: 34px;
    display: flex;
    align-items: center;
    &:last-child{
      border: none;
    }
    &:before{
      content:"";
      position:absolute;
      right: 0;
      width: 28px;
      height: 28px;
      background: #537FE4;
      border-radius: 20px;
    }
    &:after{
      content: "";
      position: absolute;
      right: 11px;
      width: 10px;
      height: 10px;
      background: #537FE4;
      border-top: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(45deg);
    }
  }

}
.head-img-pickup{
  width: 284px;
  margin: auto;
  margin-bottom: 12px;
}
.head-img-3years{
  width: 232px;
  margin: auto;
  margin-bottom: 24px;
}
.year-img{
  margin-bottom: 24px;
}

.btn{
  background: linear-gradient(270deg, #5BEAE8 0%, #537FE4 100%);
  border-radius: 35px;
  border: none;
  padding: 14px 0;
  width: 80%;
  margin: auto;
  display: block;
  line-height: 1;
  font-size: 16px;
  height: auto;
  font-weight: 600;
}

.block-next-announce{
  background: #fff;
  margin: 20px;
  border: 1px dashed $tori_navy;
  position: relative;
  border-radius: 10px;
  padding: 40px 20px;
  h3{
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 21px;
    text-align: center;
    color: $tori_navy;
    margin: 0;
    margin-bottom: 24px;
  }
  p{
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 28px;
    color: $tori_navy;
    margin: 0;
  }
}
.attention{
  font-size: 16px;
  font-weight: 600;
  padding: 0 0 2px;
  background: linear-gradient(transparent 70%, #ffef6b 30%);
}

.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  width: 88vw;
  margin: auto;
  margin-bottom: 30px;
  text-align: center;
  color: var(--key-color);
  font-size: 16px;
  @include mq('w580') {
    width: 80%;
  }
  .br-pc {
    display: none;
    @include mq('w580'){
      display: inline;
    }
  }

  .error-title {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .links {
    font-weight: bold;
    margin-bottom: 16px;
  }
  ul {
    margin-bottom: 12px;
    li {
      color: red;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      margin: 0 auto;
      padding-left: 20vw;
      @include mq('w580') {
        width: 50%;
        padding: 0;
      }
    }
  }
  a {
    color: #547fe4;
    text-decoration: none;
    border-bottom: 1px solid red;
    padding-bottom: 3px;
    font-weight: bold;
  }
}


.block-baika-shineki{
  background: #fff;
  margin: 20px;
  border: 1px solid $tori_navy;
  border-radius: 10px;
  padding: 40px 20px;
  .head-img-baika{
    width: 144px;
    margin: auto;
    margin-bottom: 24px;
  }
  p{
    font-size: 16px;
    margin-bottom: 16px;
  }
  h4{
    color: $tori_navy;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 16px;
    margin-top: 24px;
  }
  ul{
    background: $tori_lightblue;
    padding: 16px;
    margin-bottom: 16px;
    li{
      color: $tori_navy;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
.intro-text{
  width: 100%;
  max-width: 580px;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: $tori_navy;
  margin: 0 auto 8px;
  padding: 0 20px;
  text-align: center;
  @include mq('w580'){
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 36px;
  }
}
</style>

<style>
.footer {
  display: none!important;
}
</style>





// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/ProductsKurenotoriIndex.vue